export default function LocationIcon() {
    return (
        <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.75 7.375C13.75 12.3333 7.375 16.5833 7.375 16.5833C7.375 16.5833 1 12.3333 1 7.375C1 5.68424 1.67165 4.06274 2.86719 2.86719C4.06274 1.67165 5.68424 1 7.375 1C9.06576 1 10.6873 1.67165 11.8828 2.86719C13.0783 4.06274 13.75 5.68424 13.75 7.375Z" stroke="#F3F3F3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7.375 9.5C8.5486 9.5 9.5 8.5486 9.5 7.375C9.5 6.20139 8.5486 5.25 7.375 5.25C6.20139 5.25 5.25 6.20139 5.25 7.375C5.25 8.5486 6.20139 9.5 7.375 9.5Z" stroke="#F3F3F3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
